import React, { useEffect, useState } from 'react'; 
import { CircularProgress } from '@mui/material';
import { apiUrl} from "../config/default";


export default function StatisticsCounter() {

    const [contentData, setContentData] = useState<any>(null);
    const [isReady, setIsReady] = React.useState(false);
    useEffect(()=> {

        fetchData();
        
    }, []);

    const fetchData =() =>{
        let url = apiUrl + "/catalogs/externalBrowse";



        fetch(url)
        .then(res => res.json())
        .then(
          (result) => {
            if(!result || !result.data) {
                setContentData(null);
            }
            let total_length = result.data.length;
            let pos = result.data.filter(function(v:any) {
                return v.curation_status === 'positive'
            });
            let positive_length = pos.length;
            let metrics = {"total":total_length, "enhancer": positive_length}
            setContentData(metrics);
            
          }, 
          (error:any) => {
            setContentData(null);
          }
          
        );
        setIsReady(true);

    };

    const getCurrentDate = () => {
        let today = new Date();
        let year = today.getFullYear();
        let month = today.getMonth() + 1;
        let day = today.getDate();
        return(
            <span>{month}/{day}/{year}</span>
        )
    };


    if(!contentData){
        if(!isReady) {
            return(<>
            
            <div style={{minHeight:"70vh", background:"white",opacity:"1.0",zIndex: 100,position: 'fixed', top: 0,right: 0,bottom: 0,left: 0}}>
              <CircularProgress
                  variant="indeterminate"
                  disableShrink 
                  size={100}
                  sx={{ 
                      position: 'absolute',
                      marginLeft: "auto",
                      marginRight: "auto",
                      left: 0,
                      right: 0,
                      top:"50%",
                      textAlign: "center",
                      zIndex: 111
                  }}
              /> 
              </div>
              
            
            </>);
          }
          else {
            return null;
          }
    }
        


    return(
        <div>
        <i className='pi pi-info-circle'> </i> As of <span style={{color:"red"}}>{getCurrentDate()}</span>, the database contains information on <span style={{color:"red"}}>{contentData.total}</span> <i>in vivo</i> tested elements - <span style={{color:"red"}}>{contentData.enhancer}</span> elements with enhancer activity. 
        </div>
    )
}